module.exports = __webpack_public_path__ + "static/media/mateusz-wozniak.8f7bcc32.jpg";